import React from "react";
import { string } from "prop-types";

const FieldError = (props) => {
    const { error, errorClassName } = props;

    return (
        error && (
            <div className={`form-group-error ${errorClassName}`}>
                <span>{error}</span>
            </div>
        )
    );
};

FieldError.propTypes = {
    error: string.isRequired,
    errorClassName: string,
};

FieldError.defaultProps = {
    errorClassName: "",
};

export default FieldError;
